import { rebottle } from "../elements";
import type { BottleType, CanvasData } from "../schema";
import { INK, centred, doc, ornament, ornamentPoint } from "./kit";
import type { LabelTemplate } from "./types";

// Sparkling / MCC formal, authored MCC-first on the 80 × 100 label; the wine
// label is the same design re-bottled (it gains 5 mm of air each side).
function mcc(): CanvasData {
  const b = "mcc";
  const ribbon = ornament("straight-ribbon", INK.gold, { width: 40, at: [40, 61.6], anchor: [150, 21] });
  const band = ornamentPoint(ribbon, 150, 21);
  return doc(b, INK["warm-white"], [
    ornament("heater-shield", INK.charcoal, { width: 14, at: [40, 22] }),
    centred(b, { text: "YOUR HOUSE", font: "cinzel", size: 6, color: INK.charcoal, baseline: 46, tracking: 0.08 }),
    centred(b, { text: "Méthode Cap Classique", font: "cormorant", italic: true, size: 3, color: INK.charcoal, baseline: 54, tracking: 0.03 }),
    ribbon,
    centred(b, { text: "Brut", font: "cinzel", size: 2.6, color: INK.charcoal, baseline: band[1] + 1.3, tracking: 0.2 }),
    centred(b, { text: "2026", font: "montserrat", size: 1.8, color: INK.charcoal, baseline: 86, tracking: 0.2 }),
  ]);
}

export const sparklingFormal: LabelTemplate = {
  key: "sparkling-formal",
  name: "Sparkling formal",
  occasion: "sparkling",
  style: "MCC formal",
  description: "A crest, the house name and a Brut ribbon for Cap Classique.",
  hasImageSlot: false,
  build: (bottle: BottleType) => (bottle === "mcc" ? mcc() : rebottle(mcc(), bottle)),
};
